<form [formGroup]="processForm" id="processForm">
  <div formArrayName="processes">
    @for (process of getProcesses().controls; track process; let i = $index) {
      <div>
        <div [formGroupName]="i" class="row">
          <!-- #region Welder Stamps -->
          @if (showAcceptReject == 0) {
            <div class="col-3">
              <label>Welder Id <span style="color: red">*</span></label>
              <p-select
                optionValue="id"
                optionLabel="name"
                formControlName="stampid"
                placeholder="Select a Welder"
                [options]="_srvDropDown.stampAllocation.items"
                appendTo="body"
                (onChange)="enableDisableWelders()"
                [filter]="true"
              ></p-select>
            </div>
          }
          <!-- #endregion Welder Stamp -->
          <!-- #region Processes -->
          @if (showAcceptReject == 0) {
            <div class="col-6">
              <label>Processes <span style="color: red">*</span></label>
              <p-multiSelect
                optionValue="id"
                optionLabel="name"
                formControlName="processids"
                placeholder="Select a Process"
                [options]="_srvDropDown.WeldProcesses.items"
                (onChange)="sendData()"
                appendTo="body"
              ></p-multiSelect>
            </div>
          }
          <!-- #endregion Processes -->
          <!-- #region Accept/Reject -->
          @if (showAcceptReject == 1) {
            <div class="col-3">
              <label>Accept/Reject </label>
              <p-select
                name="rtacceptedRejected"
                optionValue="value"
                optionLabel="label"
                formControlName="rtacceptedRejected"
                placeholder="Select Accept/Reject"
                [options]="acceptedRejectedDTO"
                (onChange)="sendData()"
                appendTo="body"
              ></p-select>
            </div>
          }
          <!-- #endregion -->
        </div>
      </div>
    }
  </div>
</form>

